export default {
  SET_FEEDS(state, feeds) {
    if (state.feedPage === 1)
      state.feeds = [...feeds]
    else 
      state.feeds = [...state.feeds, ...feeds]
  },
  setFollowed(state, payload) {
    state.contributors = payload;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_FOLLOWED_ORGS(state, payload){
    state.followedOrgs = payload
  },
  SET_ALL_CONTRIBUTORS(state, payload){
    state.allContributors = payload
  },
  // feedReaction(state, payload) {
  //   state.feeds = [...state.feeds.map(feed => {
  //     if (feed.id === payload.id) {
  //       feed = { ...payload }
  //     }
  //     return feed
  //   })]
  // },
  feedReaction(state, payload) {
    const index = state.feeds.findIndex(feed => feed.id === payload.id);
    if (index !== -1) {
      state.feeds[index] = { ...payload };
    }
  },
  SET_SCROLL_HEIGHT(state, payload){
    state.innerHeight = payload
  },
  SET_FEED_PAGE_SIZE(state, payload) {
    state.feedPage = payload
  },
  UPDATE_FEED_LIST (state,payload) {
    payload.forEach((feed)=>{
      const feedExists = state.feeds.find(existingFeed => existingFeed.id === feed.id)
      if(!feedExists)
        state.feeds.push(feed)
    })

    state.feeds = [...state.feeds]
  },
  SET_HAS_MORE_PAGES(state, limit) {
    if (limit === 'exceeded')
      state.hasMoreFeedPages = false
    else if (limit === 'remaining')
      state.hasMoreFeedPages = true
  },
  SET_RECOMMENDED_CONNECTIONS(state, recommendations){
    state.recommendedConnections = recommendations
  },
  SET_RECOMMENDED_ORGANIZATIONS(state, recommendations){
    state.recommendedOrganizations = recommendations
  },
  SET_ACTIVITY_POST(state, payload=[]){
    payload.forEach(activity=>{
      if (activity?.post)
      state.postActivity.set(activity?.post?.id, activity?.post)
    })
  },
  SET_ACTIVITY_COMMENT(state, payload=[]){
    payload.forEach(activity=>{
      if (activity?.post)
      state.commentActivity.set(activity?.post?.id, activity?.post)
    })
  },
  ADD_COMMENT_IN_ACTIVITY_IN_COMMENT(state, {postId, parentCommentId=null, updatedComment}){
    if (state.commentActivity.has(postId)){
      const post = state.commentActivity.get(postId)
      if (parentCommentId){
        const commentIndex = post.comments.findIndex(comment=>comment?.id === parentCommentId )
        post.comments[commentIndex].child.unshift(updatedComment)
      }
      else{
        const post = state.commentActivity.get(postId)
        post.comments.unshift(updatedComment)
      }
       state.commentActivity.set(updatedComment?.post, post)
    }

  },
  DELETE_ACTIVITY_COMMENTS(state, {commentId, parentCommentId=null, postId}){
    if (state.commentActivity.has(postId)){
      const post = state.commentActivity.get(postId)
      const commentIndex = post.comments.findIndex(comment=>comment?.id === commentId || comment?.id === parentCommentId )
      if (parentCommentId){
        const childCommentIndex = post.comments[commentIndex].child.findIndex(comment=>comment?.id === commentId)
        post.comments[commentIndex].child.splice(childCommentIndex, 1)
      }
      else{
        post.comments.splice(commentIndex, 1)
      }
      state.commentActivity.set(postId, post)
    }
  },
  SET_FEED_COMMENTS(state, feedComments){
    feedComments.forEach(comment=>{
      if (comment?.id){
        state.feedComments.set(comment?.id, comment)
        const doesExist = state.feedCommentsIdArray.includes(comment?.id)
        if (!doesExist)
          state.feedCommentsIdArray.push(comment?.id)
      }
    })
  },
  ADD_NEW_COMMENT_IN_FEED(state, comment){
    if (comment?.parent){ // when adding a child you don't need to add the parent comment id to feedCommentsIdArray
      const fetchParentComment =  state.feedComments.get(comment?.parent)
      fetchParentComment.child.unshift(comment)
      state.feedComments.set(comment?.parent, fetchParentComment)
    }
    else{
      state.feedComments.set(comment?.id, comment)
        const doesExist = state.feedCommentsIdArray.includes(comment?.id)
        if (!doesExist)
          state.feedCommentsIdArray.unshift(comment?.id)
    }
  },
  DELETE_FEED_COMMENT(state, {comment_id, parentCommentId=null}){
    if (parentCommentId){
      const parentComment = state.feedComments.get(parentCommentId)
      parentComment.child = parentComment.child.filter(commentId=>commentId?.id !== comment_id)
      state.feedComments.set(parentCommentId, parentComment)
    }
    else{
      state.feedCommentsIdArray = state.feedCommentsIdArray.filter(commentId=>commentId !== comment_id)
      state.feedComments.delete(comment_id)
    }
  },
  EDIT_FEED_COMMENT(state, {comment_id, parentCommentId=null, updatedComment}){
    if (parentCommentId){
      const parentComment = state.feedComments.get(parentCommentId)
      const childCommentIndex = parentComment.child.findIndex(comment=>comment?.id === comment_id)
      parentComment.child[childCommentIndex] = {...updatedComment}
      state.feedComments.set(parentCommentId, parentComment)
    }
    else{
      state.feedComments.set(comment_id, updatedComment)
    }
  },
  SET_ALL_ORGANIZATION(state, nonContributorOrganizations){
    state.allOrganization = nonContributorOrganizations

  },
  SET_SHARED_POST_ID(state, postId){
    state.sharedPostId = postId
  },
  UPDATE_ACTIVITY_PAGE_COUNTER(state, counter){
    state.activityPage = counter
  },
  SET_ACTIVITY_PAGE_LIMIT(state, limit){
    if (limit === 'exceeded')
      state.hasMoreActivityPages = false
    else if (limit === 'remaining')
      state.hasMoreActivityPages = true
  },
  UPDATE_COMMENT_PAGE_COUNTER(state, counter){
    state.commentPage = counter
  },
  SET_COMMENT_PAGE_LIMIT(state, limit){
    if (limit === 'exceeded')
      state.hasMoreCommentPages = false
    else if (limit === 'remaining')
      state.hasMoreCommentPages = true
  },
  DELETE_COMMENT_FROM_ACTIVITY(state, id){
    state.postActivity.delete(id)
  },
  SET_ACTIVE_KEY(state, activeKeyDetails={}){
    state.activeKey = activeKeyDetails
  },
  DELETE_POST_FROM_ACTIVITY_AND_FEED(state, id){
    if (state.postActivity.has(id)){
      state.postActivity.delete(id)
    }
    state.feeds = state.feeds.filter(feed => feed?.id !== id)
  },
  ADD_POST_TO_FEED_AND_MY_ACTIVITY(state, post){
    state.feeds.unshift(post)
    state.postActivity.set(post?.id, post)
  }
};